import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const GetStudentsOfClass = async (ClassID) => {
  try {
    const UsersCollection = collection(db, "Users");

    const q = query(
      UsersCollection,
      where("UserType", "==", "student"),
      where("AdditionalDetails.ClassID", "==", ClassID)
    );
    const UsersSnapshot = await getDocs(q);

    let UsersData = [];

    UsersSnapshot.forEach((doc) => {
      UsersData.push({ ...doc.data(), id: doc.id });
    });
    return UsersData;
  } catch (error) {
    console.log(error);
  }
};

export default GetStudentsOfClass;
